"use client"
import { HashRouter as Router, Routes, Route } from "react-router-dom"
import Home from "./pages/Home"
import AboutUs from "./pages/AboutUs"
import ContactUs from "./pages/ContactUs"
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Register from "./pages/Register"
import Admin from "./pages/Admin"
import CheckIn from "./pages/CheckIn"
import PaymentConfirmation from "./pages/PaymentConfirmation"
import TravelBookings from "./pages/TravelBookings"
import Quote from "./pages/Quote"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import ConfirmedCompanies from "./pages/ConfirmedCompanies"
import Gallery from "./pages/Gallery"
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { pageview } from "./utils/ga"

// Component that reports route changes to Google Analytics
function Analytics() {
  const location = useLocation()
  useEffect(() => {
    pageview(location.pathname + location.hash)
  }, [location])
  return null
}

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <HelmetProvider>
      <Router>
        <Analytics />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/check-in" element={<CheckIn />} />
            <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
            <Route path="/TravelBookings" element={<TravelBookings />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/confirmed-companies" element={<ConfirmedCompanies />} />
            <Route path="/gallery" element={<Gallery />} />
            {/* Add a catch-all route for hash-based navigation */}
            <Route
              path="*"
              element={
                <div className="container mx-auto p-4">
                  <h1 className="text-2xl font-bold mb-4">Page Not Found</h1>
                  <p>The page you're looking for doesn't exist or has been moved.</p>
                </div>
              }
            />
          </Routes>
        </main>
        <Footer />
      </Router>
      </HelmetProvider>
    </div>
  )
}

export default App
